'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _validation = require('utils/validation');

var _reactDatepicker = require('react-datepicker');

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _reactBootstrap = require('react-bootstrap');

var _lodash = require('lodash');

var _lib = require('helpers/lib');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderHour(bookingDate, bookingOnTime) {
  var hourOption = [];
  if (!bookingOnTime) {
    return hourOption;
  }
  var currentHour = new Date().getHours() * 60;
  var checkTime = false;
  if (bookingDate && (0, _moment2.default)(bookingDate.date).format('YYYY-MM-DD') === (0, _moment2.default)(new Date()).format('YYYY-MM-DD')) {
    checkTime = true;
  }
  for (var index = 0; index < bookingOnTime.length; index++) {
    var bOT = bookingOnTime[index];
    var hourCheck = true;
    if (checkTime) {
      hourCheck = currentHour < bOT.time;
    }
    if (hourCheck) {
      hourOption.push({
        id: bOT._id,
        available: bOT.empty > 0 && bOT.status === 'available' ? true : false,
        hour: (0, _lib.number2Time)(bOT.time),
        empty: bOT.empty
      });
    }
  }
  return hourOption;
}
var Booking = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    requesting: state.shops.requesting,
    datesHaveBooking: state.shops.datesHaveBooking,
    requested: state.shops.requested,
    messRequest: state.shops.messRequest,
    errorsRequest: state.shops.errorsRequest,
    bookingDate: state.shops.bookingDate
  };
}, (0, _extends3.default)({}, shopActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Booking, _Component);

  function Booking() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Booking);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Booking.__proto__ || (0, _getPrototypeOf2.default)(Booking)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showModalBooking: false,
      bookDate: _this.props.datesHaveBooking && (0, _moment2.default)(new Date(_this.props.datesHaveBooking[0])) || (0, _moment2.default)(),
      hour: null,
      showOptionHourIn: false,
      showOptionHourOut: false,
      booking: {
        bookingTime: '',
        slot: 1,
        user: _this.props.user && _this.props.user._id || '',
        note: '',
        email: _this.props.user && _this.props.user.email || '',
        name: _this.props.user && _this.props.user.profile && _this.props.user.profile.name || '',
        phone: _this.props.user && _this.props.user.profile && _this.props.user.profile.phone || ''
      },
      validation: {}
    }, _this.handleChangeBookDate = function (date) {
      _this.setState({
        bookDate: date,
        showOptionHourIn: false,
        showOptionHourOut: false,
        change: true
      });
      _this.props.getBooking(_this.props.id, date);
    }, _this.handleChangeHour = function (hour) {
      var obj = _this.state.booking;
      obj.bookingTime = hour.id;
      _this.setState({
        hour: hour,
        booking: obj,
        showOptionHourIn: false,
        showOptionHourOut: false,
        change: true
      });
    }, _this.handleSubmitBooking = function (event) {
      event.preventDefault();
      if (_this.props.user) {
        _this.setState({ showModalBooking: true });
      } else {
        _this.props.openLogin();
      }
    }, _this.handleCloseBooking = function () {
      _this.setState({ showModalBooking: false });
      _this.props.resetRequest();
    }, _this.handleDisplayOptionHourIn = function () {
      _this.setState({ showOptionHourIn: !_this.state.showOptionHourIn });
    }, _this.handleDisplayOptionHourOut = function () {
      _this.setState({ showOptionHourOut: !_this.state.showOptionHourOut });
    }, _this.handleChangeBooking = function (event) {
      var field = event.target.name;
      var value = event.target.value;
      var obj = _this.state.booking;
      obj[field] = value;
      _this.setState({ booking: obj, change: true });
    }, _this.handleBookingFinal = function (event) {
      event.preventDefault();
      var booking = _this.state.booking;
      var user = _this.props.user;
      if (!booking.user) {
        booking.user = user._id;
      }
      if (!booking.email) {
        booking.email = user.email;
      }
      if (!booking.name) {
        booking.name = user.profile.name;
      }
      if (!booking.phone) {
        booking.phone = user.profile.phone;
      }
      var surveyValidation = (0, _validation.createValidator)({
        bookingTime: [_validation.required],
        slot: [_validation.required],
        phone: [_validation.required]
      });
      var errors = surveyValidation(booking);
      if ((0, _lodash.isEmpty)(errors)) {
        _this.setState({ validation: {}, change: false });
        _this.props.requestBooking(booking);
      } else {
        var validation = { all: '' };
        if (errors.phone) {
          validation.all = 'Vui lòng cung cấp số điện thoại để chúng tôi gọi cho bạn!';
        }
        if (errors.slot) {
          validation.all = 'Số chỗ phải lớn hơn 0 và bé hơn số chỗ hiện có';
        }
        if (errors.bookingTime) {
          validation.all = 'Vui lòng chọn thời gian booking!';
        }
        _this.setState({ validation: validation, change: false });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Booking, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.getBooking(this.props.id, this.state.bookDate);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.user && !(0, _lodash.isEqual)(nextProps.user, this.props.user)) {
        var booking = this.state.booking;
        booking.email = nextProps.user.email;
        booking.name = nextProps.user.profile.name;
        booking.phone = nextProps.user.profile.phone;
        booking.user = nextProps.user._id;
        this.setState({ booking: booking });
      }
      if (nextProps.datesHaveBooking && nextProps.datesHaveBooking[0] && !(0, _lodash.isEqual)(nextProps.datesHaveBooking, this.props.datesHaveBooking)) {
        var date = (0, _moment2.default)(new Date(nextProps.datesHaveBooking[0]));
        this.setState({
          bookDate: date,
          showOptionHourIn: false,
          showOptionHourOut: false,
          change: true
        });
        this.props.getBooking(this.props.id, date);
      }
      if (!(0, _lodash.isEqual)(nextProps.bookingDate, this.props.bookingDate)) {
        var hour = null;
        var _booking = this.state.booking;
        this.setState({ hour: hour, booking: _booking });
      }
      if (!(0, _lodash.isEqual)(nextProps.messRequest, this.props.messRequest)) {
        this.props.getBooking(this.props.id, this.state.bookDate);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Detail.scss');
      var _props = this.props,
          bookingDate = _props.bookingDate,
          requesting = _props.requesting,
          requested = _props.requested,
          messRequest = _props.messRequest,
          errorsRequest = _props.errorsRequest,
          datesHaveBooking = _props.datesHaveBooking;
      var _state = this.state,
          showOptionHourIn = _state.showOptionHourIn,
          showOptionHourOut = _state.showOptionHourOut,
          booking = _state.booking,
          hour = _state.hour,
          bookDate = _state.bookDate,
          showModalBooking = _state.showModalBooking,
          validation = _state.validation,
          change = _state.change;

      var bookingOnTime = bookingDate && bookingDate.bookingOnTime || [];
      var hourOption = renderHour(bookingDate, bookingOnTime);
      var dates = [];
      if (datesHaveBooking) {
        datesHaveBooking.map(function (date) {
          dates.push((0, _moment2.default)(new Date(date)));
        });
      }
      return _react2.default.createElement(
        'div',
        { className: styles.actions },
        _react2.default.createElement(
          'div',
          { className: styles.headerAction },
          '\u0110\u1EB7t ch\u1ED7',
          ' ',
          (!hourOption || hourOption.length === 0) && _react2.default.createElement(
            'span',
            { className: styles.error },
            'Shop v\u1EABn ch\u01B0a l\xEAn l\u1ECBch cho ng\xE0y n\xE0y, vui l\xF2ng ch\u1ECDn ng\xE0y kh\xE1c.'
          )
        ),
        _react2.default.createElement(
          'form',
          { onSubmit: this.handleSubmitBooking, className: styles.formGroup },
          _react2.default.createElement(
            'div',
            { className: styles.groupInput + ' ' + styles.date },
            _react2.default.createElement(
              'label',
              { htmlFor: 'date' },
              'Ng\xE0y \u0111\u1EB7t'
            ),
            _react2.default.createElement(_reactDatepicker2.default, {
              selected: bookDate,
              includeDates: dates,
              minDate: (0, _moment2.default)(),
              maxDate: (0, _moment2.default)().add(14, 'days'),
              onChange: this.handleChangeBookDate,
              dateFormat: 'YYYY/MM/DD'
            }),
            _react2.default.createElement('i', { className: 'fa fa-calendar ' + styles.iconCalendar })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.groupInput + ' ' + styles.hour },
            _react2.default.createElement(
              'label',
              { htmlFor: 'hour' },
              'Gi\u1EDD \u0110\u1EB7t'
            ),
            _react2.default.createElement(
              'div',
              {
                className: styles.selectHour,
                onClick: function onClick() {
                  return _this2.handleDisplayOptionHourOut();
                }
              },
              hour && _react2.default.createElement('i', {
                className: 'fa ' + (hour.available ? 'fa-check' : 'fa-times') + ' ' + styles.checkIcon
              }),
              hour && hour.hour,
              _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.arrowDown, glyph: 'menu-down' })
            ),
            showOptionHourOut && _react2.default.createElement(
              'div',
              { className: styles.optionHourList },
              hourOption.map(function (opt, index) {
                if (!opt.available) {
                  return _react2.default.createElement(
                    'div',
                    {
                      key: index,
                      className: styles.optionHour + ' ' + styles.isSelected
                    },
                    _react2.default.createElement('i', { className: 'fa fa-times ' + styles.timesIcon }),
                    opt.hour
                  );
                }
                return _react2.default.createElement(
                  'div',
                  {
                    key: index,
                    onClick: function onClick() {
                      return _this2.handleChangeHour(opt);
                    },
                    className: styles.optionHour + ' ' + ((0, _lodash.isEqual)(opt, hour) ? styles.isSelected : '')
                  },
                  _react2.default.createElement('i', { className: 'fa fa-check ' + styles.checkIcon }),
                  opt.hour
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.groupInput + ' ' + styles.number },
            _react2.default.createElement(
              'label',
              { htmlFor: 'number' },
              'S\u1ED1 Slot (' + (hour && hour.empty ? hour.empty : 0) + ')'
            ),
            _react2.default.createElement('input', {
              id: 'hour',
              name: 'slot',
              min: 1,
              max: hour && hour.empty,
              type: 'number',
              onChange: this.handleChangeBooking,
              value: booking.slot
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.groupInput + ' ' + styles.button },
            _react2.default.createElement(
              'button',
              { type: 'submit' },
              '\u0110\u1EB7t'
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            bsSize: 'small',
            onHide: this.handleCloseBooking,
            show: showModalBooking,
            hide: this.handleCloseBooking
          },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            { closeButton: true },
            _react2.default.createElement(
              _reactBootstrap.Modal.Title,
              null,
              _react2.default.createElement(
                'div',
                { className: styles.headerModalImage },
                '\u0110\u1EB7t ch\u1ED5'
              )
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            null,
            !requested || !(0, _lodash.isEmpty)(errorsRequest) || !(0, _lodash.isEmpty)(validation) ? _react2.default.createElement(
              'form',
              {
                onSubmit: this.handleBookingFinal,
                className: styles.bookingContent
              },
              !(0, _lodash.isEmpty)(errorsRequest) && errorsRequest.all && !change && _react2.default.createElement(
                _reactBootstrap.Alert,
                { bsStyle: 'danger' },
                errorsRequest.all
              ),
              !(0, _lodash.isEmpty)(validation) && validation.all && !change && _react2.default.createElement(
                _reactBootstrap.Alert,
                { bsStyle: 'danger' },
                validation.all
              ),
              _react2.default.createElement(
                'div',
                { className: styles.groupInfo },
                _react2.default.createElement(
                  'div',
                  { className: styles.headerGroupInfo },
                  'Th\xF4ng tin \u0111\u1EB7t ch\u1ED7'
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.actions },
                  _react2.default.createElement(
                    'div',
                    { className: styles.formGroup },
                    _react2.default.createElement(
                      'div',
                      { className: styles.groupInput + ' ' + styles.date },
                      _react2.default.createElement(
                        'label',
                        { htmlFor: 'date' },
                        'Ng\xE0y \u0111\u1EB7t'
                      ),
                      _react2.default.createElement(_reactDatepicker2.default, {
                        selected: bookDate,
                        minDate: (0, _moment2.default)(),
                        maxDate: (0, _moment2.default)().add(14, 'days'),
                        onChange: this.handleChangeBookDate,
                        dateFormat: 'YYYY/MM/DD'
                      }),
                      _react2.default.createElement('i', {
                        className: 'fa fa-calendar ' + styles.iconCalendar
                      })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.groupInput + ' ' + styles.hour },
                      _react2.default.createElement(
                        'label',
                        { htmlFor: 'hour' },
                        'Gi\u1EDD \u0110\u1EB7t'
                      ),
                      _react2.default.createElement(
                        'div',
                        {
                          className: styles.selectHour,
                          onClick: function onClick() {
                            return _this2.handleDisplayOptionHourIn();
                          }
                        },
                        hour && _react2.default.createElement('i', {
                          className: 'fa ' + (hour.available ? 'fa-check' : 'fa-times') + ' ' + styles.checkIcon
                        }),
                        hour && hour.hour,
                        _react2.default.createElement(_reactBootstrap.Glyphicon, {
                          className: styles.arrowDown,
                          glyph: 'menu-down'
                        })
                      ),
                      showOptionHourIn && _react2.default.createElement(
                        'div',
                        { className: styles.optionHourList },
                        hourOption.map(function (opt, index) {
                          if (!opt.available) {
                            return _react2.default.createElement(
                              'div',
                              {
                                key: index,
                                className: styles.optionHour + ' ' + styles.isSelected
                              },
                              _react2.default.createElement('i', {
                                className: 'fa fa-times ' + styles.timesIcon
                              }),
                              opt.hour
                            );
                          }
                          return _react2.default.createElement(
                            'div',
                            {
                              key: index,
                              onClick: function onClick() {
                                return _this2.handleChangeHour(opt);
                              },
                              className: styles.optionHour + ' ' + ((0, _lodash.isEqual)(opt, hour) ? styles.isSelected : '')
                            },
                            _react2.default.createElement('i', {
                              className: 'fa fa-check ' + styles.checkIcon
                            }),
                            opt.hour
                          );
                        })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.groupInput + ' ' + styles.number },
                      _react2.default.createElement(
                        'label',
                        { htmlFor: 'number' },
                        'S\u1ED1 Slot (' + (hour && hour.empty ? hour.empty : 0) + ')'
                      ),
                      _react2.default.createElement('input', {
                        id: 'hour',
                        name: 'slot',
                        min: 1,
                        max: hour && hour.empty,
                        type: 'number',
                        onChange: this.handleChangeBooking,
                        value: booking.slot
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.inputBooking + ' form-group' },
                  _react2.default.createElement('input', {
                    name: 'note',
                    type: 'text',
                    onChange: this.handleChangeBooking,
                    value: booking.note,
                    className: 'form-control',
                    placeholder: 'Note'
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.groupInfo },
                _react2.default.createElement(
                  'div',
                  { className: styles.headerGroupInfo },
                  'Th\xF4ng tin li\xEAn h\u1EC7'
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.inputBooking + ' input-group' },
                  _react2.default.createElement(
                    'span',
                    { className: 'input-group-addon' },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'user' })
                  ),
                  _react2.default.createElement('input', {
                    name: 'name',
                    type: 'text',
                    onChange: this.handleChangeBooking,
                    value: booking.name,
                    className: 'form-control',
                    placeholder: 'T\xEAn ng\u01B0\u1EDDi \u0111\u1EB7t'
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.inputBooking + ' input-group' },
                  _react2.default.createElement(
                    'span',
                    { className: 'input-group-addon' },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'envelope' })
                  ),
                  _react2.default.createElement('input', {
                    name: 'email',
                    type: 'email',
                    onChange: this.handleChangeBooking,
                    value: booking.email,
                    className: 'form-control',
                    placeholder: 'Email'
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.inputBooking + ' input-group' },
                  _react2.default.createElement(
                    'span',
                    { className: 'input-group-addon' },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'earphone' })
                  ),
                  _react2.default.createElement('input', {
                    name: 'phone',
                    type: 'tel',
                    onChange: this.handleChangeBooking,
                    value: booking.phone,
                    className: 'form-control',
                    placeholder: '\u0110i\u1EC7n tho\u1EA1i'
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.groupInput + ' ' + styles.button },
                _react2.default.createElement(
                  'button',
                  { type: 'submit' },
                  requesting ? _react2.default.createElement(_reactBootstrap.Glyphicon, {
                    className: styles.icon + ' ' + styles.iconSpin,
                    glyph: 'repeat',
                    spin: 'true'
                  }) : 'Đặt'
                )
              )
            ) : _react2.default.createElement(
              'div',
              { className: styles.bookingContent },
              _react2.default.createElement(
                _reactBootstrap.Alert,
                { bsStyle: 'success' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Th\xE0nh C\xF4ng!'
                ),
                ' ',
                messRequest
              )
            )
          )
        )
      );
    }
  }]);
  return Booking;
}(_react.Component), _class2.propTypes = {
  bookingDate: _react.PropTypes.object,
  datesHaveBooking: _react.PropTypes.array,
  getBooking: _react.PropTypes.func.isRequired,
  id: _react.PropTypes.string,
  openLogin: _react.PropTypes.func.isRequired,
  requestBooking: _react.PropTypes.func.isRequired,
  resetRequest: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object,
  requesting: _react.PropTypes.bool,
  requested: _react.PropTypes.bool,
  messRequest: _react.PropTypes.string,
  errorsRequest: _react.PropTypes.object
}, _temp2)) || _class);
exports.default = Booking;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Detail/Booking.js
// module id = 1665
// module chunks = 0